import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useStoreState, useStoreActions } from 'easy-peasy';
import useSize from '@react-hook/size';
import { resizeIframeDebounced } from '~/utils';

import Checkbox from '~/components/Checkbox';
import Loader from '~/components/Loader';
import Legend from '~/components/Legend';
import Scatterplot from './Scatterplot';

const Wrapper = styled.div`
  min-height: 400px;
  margin: 20px 0;
  position: relative;
`;

const ChartFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const LegendWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;

  @media screen and (min-width: 768px) {
    left: auto;
    bottom: auto;
    top: -50px;
    right: 0;
  }
`;

const Visualisation = () => {
  const isLoading = useStoreState((state) => state.app.isLoading);
  const loadData = useStoreActions((state) => state.app.loadData);
  const toggleXScale = useStoreActions((state) => state.app.toggleXScale);
  const setTooltipData = useStoreActions(
    (state) => state.tooltip.setTooltipData
  );
  const tooltipData = useStoreState((state) => state.tooltip.data);

  // const toggleAbsRel = useStoreActions((state) => state.app.toggleAbsRel);
  const showFullXScale = useStoreState((state) => state.app.showFullXScale);
  const isRelView = useStoreState((state) => state.app.isRelView);
  const visRef = React.useRef(null);
  const [width] = useSize(visRef);

  useEffect(() => {
    loadData();
  }, []);

  const renderVis = width > 0 && !isLoading;

  useEffect(() => {
    resizeIframeDebounced();
  }, [width]);

  const handleGlobalClick = () => {
    if (tooltipData) {
      setTooltipData(null);
    }
  };

  return (
    <Wrapper ref={visRef} onClick={handleGlobalClick}>
      {renderVis ? (
        <Scatterplot
          showFullXScale={showFullXScale}
          isRelView={isRelView}
          width={width}
        />
      ) : (
        <Loader />
      )}
      <ChartFooter>
        <Checkbox
          label="gesamte Skala anzeigen"
          checked={showFullXScale}
          onChange={() => toggleXScale()}
        />
      </ChartFooter>
      <LegendWrapper>
        <Legend />
      </LegendWrapper>
    </Wrapper>
  );
};

export default Visualisation;
